import { TOption } from '@idaho-aeyc/ui-kit';
import { citiesOptionsConverter } from 'data/convertors/general.converters';
import { workshopEventsResponseConverter } from 'data/convertors/workshopApp.convertor';
import {
  TWorkshopEventsQueryParams,
  TWorkshopEventsResponseDB,
  TWorkshopEventsResponseUI,
} from 'data/types/workshopApp.types';
import { EWorkshopAppUrls } from 'data/urls/workshopApp';
import { emptySplitApi } from 'redux/helpers/slice.helpers';

const baseUrl = `${EWorkshopAppUrls.WORKSHOP_APP}`;

export const workshopAppApi = emptySplitApi('workshop-app', [
  'idahoCities',
  'workshopEvents',
]).injectEndpoints({
  endpoints: build => ({
    getIdahoCities: build.query<TOption[], void>({
      query() {
        return {
          url: `${baseUrl}/${EWorkshopAppUrls.CITIES}/${EWorkshopAppUrls.IDAHO}`,
          method: 'GET',
        };
      },
      providesTags: ['idahoCities'],
      transformResponse: (data: string[]) =>
        citiesOptionsConverter.fromDb(data),
    }),
    getWorkshopEvents: build.query<
      TWorkshopEventsResponseUI,
      TWorkshopEventsQueryParams
    >({
      query(params) {
        return {
          url: `${baseUrl}/workshop-event`,
          method: 'GET',
          params: {
            ...(params.hostId && { hostId: params.hostId }),
            ...(params.elcHostId && { elcHostId: params.elcHostId }),
            ...(params.cities?.length && { cities: params.cities }),
            ...(params.language && { language: params.language }),
            ...(params.attendanceType && {
              attendanceType: params.attendanceType,
            }),
            ...(params.ageGroups?.length && { ageGroups: params.ageGroups }),
            ...(params.additionally?.length && {
              additionally: params.additionally,
            }),
            ...(params.workshopTypes?.length && {
              workshopTypes: params.workshopTypes,
            }),
          },
        };
      },
      providesTags: ['workshopEvents'],
      transformResponse: (data: TWorkshopEventsResponseDB) =>
        workshopEventsResponseConverter.fromDb(data),
    }),
  }),
});

export const { useGetIdahoCitiesQuery, useGetWorkshopEventsQuery } =
  workshopAppApi;
